import React, { Component } from 'react'
import './App.css'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Home from './components/Home'
import Login from './components/Login'
import Navbar from './components/CustomNavbar'
import Register from './components/Register'
import AGB from './components/AGB'
import HowItWorks from './components/HowItWorks'
import Wins from './components/Wins'
import Imprint from './components/Imprint'
import Profile from './components/Profile'
import Gameplan from './components/Gameplan'
import Game from './components/Game'
import AdminPanel from './components/AdminPanel'
import ArenaView from './components/ArenaView'
import StartPage from './components/StartPage'


class App extends Component {
  render() {
    return (
      <div>
      <Router>
        <div>
          <Navbar />
          <Route exact path="/" component={StartPage} />
          <Route path="/home" component={StartPage} />
          <Route path="/login" component={Login} />
          <Route path="/register" component={Register} />
          <Route path="/agb" component={AGB} />
          <Route path="/howitworks" component={HowItWorks} />
          <Route path="/wins" component={Wins} />
          <Route path="/imprint" component={Imprint} />
          <Route path="/profile" component={Profile} />
          <Route path="/gameplan" component={Gameplan} />
          <Route path="/game" component={Game} />
          <Route path="/admin" component={AdminPanel} />
          <Route path="/arena" component={ArenaView} />


        </div>
      </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx